var _g, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSgp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 363,
    height: 164,
    viewBox: "0 0 363 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3800_41076)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 363,
    height: 164,
    rx: 22,
    fill: "#C6FF7D"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3800_41076)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_3800_41076)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.5 88.3318C314.701 53.2302 342.476 58.1188 363 73.7718L316.024 116.482C316.024 116.482 289.857 75.1793 203.853 153.65C200.549 156.664 202.578 160.47 205.456 159.342C256.884 139.18 337.041 134.401 363 151.266V208.545C363 208.545 336.482 168.174 271.992 175.076C271.992 175.076 335.198 178.476 363 230.244L312.406 236.219C312.406 236.219 276.151 172.582 201.065 173.037C197.622 173.058 196.494 177.024 199.006 178.487C256.731 212.093 334.349 263.019 363 320.11V345H253.684C261.903 315.044 258.032 282.378 234.717 248.199C246.146 279.759 245.136 319.129 233.873 345L190.106 300.729C190.106 300.729 233.605 269.741 182.971 186.174C181.491 183.732 177.093 182.024 175.715 186.458C153.305 258.536 137.06 308.515 174.02 345H-3V319.392C50.1166 323.172 85.381 311.57 111.373 260.311C74.3013 305.799 36.3198 305.297 -3 302.256L27.7795 253.652C27.7795 253.652 100.365 277.793 161.258 179.619C164.426 174.512 158.795 171.299 155.317 173.541C102.474 207.605 46.1559 233.702 -3 224.913V162.453C-3 162.453 25.1142 185.213 67.3649 178.109C67.3649 178.109 23.1814 174.607 -3 140.969L47.5941 134.994C47.5941 134.994 72.0476 175.557 155.676 159.713C158.545 159.169 159.154 152.429 154.165 152.164C54.9338 146.89 54.6017 61.5778 -3 93.9617V-21.9165L39.2953 -21.9998C39.2953 -21.9998 44.0856 61.0652 104.87 100.659C67.9341 59.5443 59.3317 30.7643 63.8558 -22L107.005 9.32473C107.005 9.32473 84.1677 81.0772 164.454 140.243C169.456 143.929 173.024 140.979 171.65 137.225C144.742 63.7224 130.64 25.6493 151.4 -21.9998L227.455 -22C174.202 6.38405 175.985 67.64 175.985 67.64C186.673 20.3647 221.668 -7.48722 256.447 -22L233.231 43.941C233.231 43.941 168.677 55.4713 188.225 136.536C188.836 139.069 190.199 142.056 191.933 142.42C193.911 142.836 195.679 139.725 196.009 139.094C236.223 62.0818 299.524 30.0446 277.667 -21.9998H363V52.4401C363 52.4401 321.1 27.9024 271.5 88.3318Z",
    fill: "#DA40FF"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 361,
    height: 162,
    rx: 21,
    stroke: "#C6FF7D",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3800_41076"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 363,
    height: 164,
    rx: 22,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3800_41076"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 366,
    height: 367,
    fill: "white",
    transform: "translate(-3 -22)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_3800_41076"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 366,
    height: 367,
    fill: "white",
    transform: "translate(-3 -22)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSgp);
export default __webpack_public_path__ + "static/media/sgp.e761f90ccd0c76ee544acf973051311d.svg";
export { ForwardRef as ReactComponent };